import CIMSFormItem from 'components/CIMSFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import UserSelect from 'components/CIMSSelect/common/UserSelect'
import { HelpMessage } from 'utils/constants'
import CIMSTextArea from 'components/CIMSTextArea'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { EJReportType } from '@cims-online/shared'

const CreateEditFormItems: React.VFC = () => {
  const types = EJReportType.values

  const options = useOptions({
    items: types,
    value: 'id',
    label: 'type',
    sort: 'type',
  })

  return (
    <>
      <NameFormItem help={HelpMessage.DesignSubmittals.Types.Name} />
      <CIMSFormItem
        name="allowanceDescription"
        label="Allowance Description"
        requiredMessage="Please enter an allowance description"
        help={HelpMessage.EngineeringJudgements.Types.AllowanceDescription}
      >
        <CIMSTextArea />
      </CIMSFormItem>
      <CIMSFormItem
        name="reportTypeId"
        label="Report Type "
        help={HelpMessage.EngineeringJudgements.Types.ReportType}
      >
        <CIMSSelect options={options} simple />
      </CIMSFormItem>
      <CIMSFormItem
        name="users"
        label="Issuers"
        help={HelpMessage.EngineeringJudgements.Types.Issuers}
      >
        <UserSelect mode="multiple" />
      </CIMSFormItem>
    </>
  )
}

export default CreateEditFormItems
